export const  createLabelValueObj = (label, value) => ({label, value})